import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { showFormatedDate } from '../../actions/utilAction';

function RecurrenceAppointmentDialog(props) {
  // console.log(" appointments list props ...", props.recurrenceAppointments);
  let { recurrenceAppointments, handleRecurrenceAppointments, isEditRecurrence } = props;

  const tableClass = classNames({
    'table': true,
    'table-striped': props.bordered,
    'table-bordered': props.bordered,
    'table-hover': true,
    'table-condensed': props.condensed,
    'customtable': true,
  });

  const handleDeleteClick = (e, obj) => {
    handleRecurrenceAppointments(e, 'Delete', obj);
  };

  const handleEditClick = (e, obj) => {
    handleRecurrenceAppointments(e, 'Edit', obj);
  };

  const renderData = () => {
    if (!recurrenceAppointments.length) {
      return (<tr>
        <td colSpan='5' className="text-center no-record">No record found.</td>
      </tr>);
    }

    return recurrenceAppointments.map((obj, index) => {
      let messages = obj.availabilityMessages.map((data) => data.message);      
      return (
        <tr key={index}>
          <td>{showFormatedDate(obj.startDateTime)}</td>
          <td>{moment(moment.utc(obj.startDateTime).format('YYYY-MM-DDTHH:mm:ss')).format('hh:mm a')}</td>
          <td>{moment(moment.utc(obj.endDateTime).format('YYYY-MM-DDTHH:mm:ss')).format('hh:mm a')}</td>
          <td>{messages.join(', ')} </td>
          <td>
            <button onClick={(e) => handleEditClick(e, obj)} type="button" title="Reschedule" className="tbactionbtn bluefont"><i className="fa fa-clock-o" aria-hidden="true"></i></button>
            <button onClick={(e) => handleDeleteClick(e, obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
          </td>
        </tr>
      );
    });
  };
  return (
    <div>
      <div className="clearfix"></div>

      <div className="row">

        <div className="col-sm-12 pdt-24">
          {isEditRecurrence ? 
            <div className="row">
                <div className="col-sm-12">
                  <div className="del-cont">
                    <div className="alert-warning mt-10">Note : Please do not exit out of this window. Exiting out of this window will delete scheduled sessions. Press continue after making the necessary edits.</div>
                  </div>
                </div>
              </div>: null}
          <div className="table-responsive">
            <table className={tableClass}>
              <thead>
                <tr>
                  <th width="15%">Appt. Date</th>
                  <th width="15%">Start Time</th>
                  <th width="15%">End Time</th>
                  <th width="40%">Message</th>
                  <th width="15%">Action</th>
                </tr>
              </thead>
              <tbody>
                {renderData()}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
}

export default RecurrenceAppointmentDialog;



// WEBPACK FOOTER //
// ./src/modules/scheduling/renderRecurrenceListContainer.js